import { render, staticRenderFns } from "./QuizTimeRemainingBox.vue?vue&type=template&id=1574fcf0&scoped=true&"
import script from "./QuizTimeRemainingBox.vue?vue&type=script&lang=js&"
export * from "./QuizTimeRemainingBox.vue?vue&type=script&lang=js&"
import style0 from "./QuizTimeRemainingBox.vue?vue&type=style&index=0&id=1574fcf0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1574fcf0",
  null
  
)

export default component.exports